// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__-ln-i","alertIcon":"ConfirmModal_alertIcon__1QXKU"};